import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import HotFeeds from "@/pages/home/components/HotFeeds";
import VideoStrip from "@/pages/home/components/VideoStrip";
import TopicBoard from "@/pages/home/components/TopicBoard";
import FaqBoard from "@/pages/home/components/FaqBoard";
import { articles, faqs } from "@/mocks/gossip";

const FEATURED_ID = "chengshibaotai-guancha";

const faqLd = faqs
  .map((f) => `{"@type":"Question","name":${JSON.stringify(f.q)},"acceptedAnswer":{"@type":"Answer","text":${JSON.stringify(f.a)}}}`)
  .join(",");

const seoJsonLd = `{
  "@context": "https://schema.org",
  "@graph": [
    {"@type":"Organization","name":"海角吃瓜","url":"https://gtpaint.cn/","description":"按热度聚合圈内新鲜瓜料与高赞讨论的娱乐内容站点"},
    {"@type":"WebSite","name":"海角吃瓜","url":"https://gtpaint.cn/","inLanguage":"zh-CN"},
    {"@type":"FAQPage","mainEntity":[${faqLd}]}
  ]
}`;

export default function HomePage() {
  const [query, setQuery] = useState("");
  const featured = articles.find((a) => a.id === FEATURED_ID) || articles[0];

  const handleSearch = (q: string) => {
    setQuery(q);
    document.getElementById("gualiao")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: seoJsonLd }}
      />
      <Header />
      <main>
        <Hero onSearch={handleSearch} />
        <HotFeeds query={query} onClearQuery={() => setQuery("")} />

        {/* 瓜单精读 - 编辑部推荐 */}
        <section className="w-full bg-foreground-950 py-12 md:py-16">
          <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 items-center gap-8 px-4 md:px-8 lg:grid-cols-2 lg:gap-12 lg:px-12">
            <div>
              <p className="inline-flex items-center gap-2 text-sm font-semibold text-accent-400">
                <i className="ri-quill-pen-fill" aria-hidden="true"></i>
                编辑部精读
              </p>
              <h2 className="mt-3 font-heading text-3xl font-bold leading-tight text-background-50 md:text-4xl">
                这瓜值得慢慢品
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-300">
                每天挑一条值得展开聊的话题，把来龙去脉、各方反应与背后门道一次讲透。
              </p>
              <p className="mt-6 font-heading text-xl font-bold leading-relaxed text-background-50 md:text-2xl">
                “{featured.title}”
              </p>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-300">
                {featured.summary}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${featured.id}`}
                  className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  阅读本期精读 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
                <Link
                  to="/category/guancha"
                  className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-50/25 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                >
                  <i className="ri-hashtag" aria-hidden="true"></i> 圈内观察
                </Link>
              </div>
            </div>
            <Link
              to={`/detail/${featured.id}`}
              className="group relative block h-[340px] w-full overflow-hidden rounded-3xl md:h-[420px]"
            >
              <img
                src={featured.image}
                alt={featured.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-background-50/20"></div>
              <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                <i className="ri-star-fill" aria-hidden="true"></i> 本期精选
              </span>
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-3 bg-gradient-to-t from-foreground-950/90 to-transparent p-5">
                <div>
                  <p className="text-xs text-background-200/80">热度 {featured.heat} · {featured.readMinutes} 分钟读完</p>
                  <p className="mt-1 text-sm font-semibold text-background-50">{featured.tags.join(" · ")}</p>
                </div>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-transform group-hover:scale-110">
                  <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          </div>
        </section>

        <VideoStrip />
        <TopicBoard />
        <FaqBoard />
      </main>
      <Footer />
    </>
  );
}